import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { HString, TranslateInPipe } from '@shared/src/public-api';
import { TotemController } from '@shared/src/controllers/totem/totem.controller';
import { TotemDto } from '@shared/src/controllers/totem/TotemDto';
import { TotemSteps } from '@shared/src/controllers/totem/TotemSteps';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
    selector: 'shared-totem-enterfinish',
    templateUrl: './shared.totem.enterfinish.component.html',
    styleUrls: ['./shared.totem.enterfinish.component.scss']
})
export class SharedTotemEnterFinishComponent implements OnInit, OnDestroy {

    constructor(
        protected totemService: TotemController,
        private translateIn: TranslateInPipe,
        private sanitizer: DomSanitizer) {

    }

    public totemSteps = TotemSteps;

    ngOnInit(): void {
    }
    ngOnDestroy() {
    }

    private _totem: TotemDto;
    @Input()
    public set totem(value: TotemDto) {
        if (this._totem === value)
            return;
        this._totem = value;
        this.loadData();
    }
    public get totem(): TotemDto {
        return this._totem;
    }

    loadData() {
    }

    getGatesToExit(): string {
        if (this.totem != null && this.totem.identificationSelected != null)
            return this.totem.identificationSelected.gatesToExit;

        return "-";
    }
    public next() {
        this.totemService.next(this.totem).subscribe(d => {
            this.totem = d;
            this.totemChange.next(d);
        });
    }

    @Output() totemChange = new EventEmitter<TotemDto>();

    @Output() onFinish: EventEmitter<any> = new EventEmitter<any>();

    public getButtonActionCode(): string {
        return "TOTEMPAGE.STEP." + HString.toUpperCase(this.totem.step) + ".BUTTON.CODE";
    }

    public getButtonActionName(): string {
        return "TOTEMPAGE.STEP." + HString.toUpperCase(this.totem.step) + ".BUTTON.NAME";
    }

    public getHelp(): string {
        return "TOTEMPAGE.STEP.ENTERFINISH.EXITBLOCKED.HELP";
    }



    public buttonOk() {
        this.onFinish.next();
    }

    pretty(value: any): string {
        return JSON.stringify(value);
    }
}


